"use strict";

const {checkForUrl} = require('./urlService');

const CONTEXT_WHITELIST = [
    /\/products\/product\.\d+\./, // PDP
    /\w+\.(test)?\.?mynuskin\.com/, // MySite
    /cart\.(\w+\.)?html/, // cart
    /checkout\.(\w+\.)?html/, // checkout
    /sign-up\/shopper-member/, // member sign up
    /shopper-account\./, // guest signup
    /\/personal-offer\./, // personal offer
    /\/static\//, // all static apps
    /\/exclusive-offer\./, // leader preview
    /\/catalog\//, // catalog/PDP3
    /\w+\.(test)?\.?nuskin\.io/ // AEM Feature Branch
];

const STORAGE_KEY = 'shoppingContext';

/**
 * Returns shoppingContext from localStorage
 *
 * @returns
 */
const getShoppingContext = () => {
    let context = null;

    if (checkForUrl()) {
        const url = window.location.href;
        const keepContext = CONTEXT_WHITELIST.some(exp => {
            return url.match(exp)
        });

        context = window.localStorage.getItem(STORAGE_KEY);
        context = context && JSON.parse(context);

        if (!keepContext && context && context.context !== 'skin_consult') {
            context = null;
        }
    }
    return context;
}

/**
 * returns shoppingContext name from localStorage
 *
 * @returns {String}
 */
const getShoppingContextName = () => {
    let context = getShoppingContext();

    return context ? context.context : null;
}

module.exports = {
    getShoppingContextName,
    getShoppingContext
};
